import type { WeightUnit } from '@repo/schema/load'

import { thousandSeparator } from './thousand-separator'

const formatKg = (weight: number) => `${thousandSeparator(weight)} kg`

const formatTonnes = (weight: number) => {
  // Three decimals is a whole kilogram, the finest weight that can be stored.
  const tonnes = Number((weight / 1000).toFixed(3))
  return `${thousandSeparator(tonnes)} t`
}

/**
 * Weight is always stored in kilograms. `unit` is the display hint recorded when
 * the load was entered; loads saved before it existed have none, so they fall
 * back to picking a unit from the magnitude.
 */
export const formatWeight = (
  weight: null | number | undefined,
  unit?: null | WeightUnit,
): string => {
  if (!weight || weight <= 0) {
    return '-'
  }
  if (unit === 'kg') {
    return formatKg(weight)
  }
  if (unit === 't') {
    return formatTonnes(weight)
  }
  return weight < 1000 ? formatKg(weight) : formatTonnes(weight)
}
